
import { ArtistTrackModel, PlaylistModel } from '@/models'
import Vue from 'vue'
import Component from 'vue-class-component'

@Component
export default class PlaylistTracks extends Vue {
    get playlist(): PlaylistModel | null {
        return this.$store.getters['playlistModule/getPlaylistById'](this.$route.params.id) || null
    }

    get tracks(): ArtistTrackModel[] {
        return this.playlist && this.playlist.tracks ? this.playlist.tracks : []
    }

    get audio() {
        return this.$store.getters['getAudio']
    }

    get currentTrack() {
        return this.$store.getters['getCurrent']
    }

    playPlaylist() {
        if (!this.tracks.length) {
            return
        }

        this.$store.commit('setTracksQueue', this.tracks)
        this.$store.commit('playTrack', this.tracks[0])
        this.audio.src = this.tracks[0].audio
        this.audio.play()
    }

    playSong(track: ArtistTrackModel) {
        this.audio.playbackRate = 1
        this.audio.src = track.audio
        this.$store.commit('setTracksQueue', this.tracks)
        this.$store.commit('playTrack', track)
        this.audio.play()
    }

    addCurrentTrack() {
        if (!this.currentTrack || !this.playlist) {
            return
        }

        this.$store.dispatch('playlistModule/addTrackToPlaylist', {
            playlistId: this.playlist.id,
            track: this.currentTrack,
        })
    }

    removeTrack(trackId: string) {
        if (!this.playlist) {
            return
        }

        this.$store.dispatch('playlistModule/removeTrackFromPlaylist', {
            playlistId: this.playlist.id,
            trackId,
        })
    }

    deletePlaylist() {
        if (!this.playlist) {
            return
        }

        this.$store.dispatch('playlistModule/deletePlaylist', this.playlist.id).then(() => {
            this.$router.push('/playlists')
        })
    }

    convertTime(secs: number | string) {
        const totalSec = Math.floor(Number(secs) || 0)
        const min = Math.floor(totalSec / 60)
        const sec = totalSec % 60
        const minute = min < 10 ? '0' + min : min
        const seconds = sec < 10 ? '0' + sec : sec
        return minute + ':' + seconds
    }

    formatDate(value: string) {
        return new Date(value).toLocaleDateString()
    }

    mounted() {
        window.scrollTo(0, 0)
        this.$store.dispatch('playlistModule/loadPlaylists')
    }
}
